"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.account = void 0;
const utils_1 = require("../utils");
const endpoint_1 = require("../endpoint/endpoint");
const parse_sort_object_1 = require("../utils/parse-sort-object");
const base = '/account';
const create = (payload, options) => {
    const url = (0, utils_1.urlFactory)(base, ``);
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'POST' },
        payload,
        options
    });
};
const show = ({ accountId }, options) => {
    const url = (0, utils_1.urlFactory)(base, `/${accountId}`);
    return new endpoint_1.Endpoint({ url, init: { method: 'GET' }, options });
};
const update = (_a, options) => {
    var { accountId } = _a, payload = __rest(_a, ["accountId"]);
    const url = (0, utils_1.urlFactory)(base, `/${accountId}`);
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'PUT' },
        payload,
        options
    });
};
const filter = (_a, options) => {
    var { page, size, sort } = _a, payload = __rest(_a, ["page", "size", "sort"]);
    const url = (0, utils_1.urlFactory)(base, `/filter`, {
        page,
        size,
        sort: (0, parse_sort_object_1.parseSortObject)(sort)
    });
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'POST' },
        payload,
        options
    });
};
const current = (options) => {
    const url = (0, utils_1.urlFactory)(base, `/my-account`);
    return new endpoint_1.Endpoint({ url, init: { method: 'GET' }, options });
};
const activateSupplier = (options) => {
    const url = (0, utils_1.urlFactory)(base, `/activate-supplier`);
    return new endpoint_1.Endpoint({ url, init: { method: 'POST' }, options });
};
const upgrade = (options) => {
    const url = (0, utils_1.urlFactory)(base, `/upgrade-account`);
    return new endpoint_1.Endpoint({ url, init: { method: 'POST' }, options });
};
const avatar = (payload, options) => {
    const url = (0, utils_1.urlFactory)(base, `/update-avatar`);
    const formData = new FormData();
    formData.append('avatar', payload.file);
    return new endpoint_1.Endpoint({
        url,
        init: {
            method: 'POST',
            body: formData,
            headers: {}
        },
        options
    });
};
exports.account = {
    create,
    update,
    current,
    activateSupplier,
    upgrade,
    avatar,
    ssr: {
        filter,
        show
    }
};
